module.exports = __webpack_public_path__ + "img/1F1F9-1F1F0.05c0c9f3.svg";